export default __webpack_public_path__ + "static/media/img_about03.50127013.png";